// extracted by mini-css-extract-plugin
export default {"row":"Row_row__anX9l","number":"Row_number__SnuYe","status":"Row_status__AlWo0","col":"Row_col__O4eVN","item":"Row_item__a0vBo"};